import styled from 'styled-components';

export const BookAboutParagraph = styled.p`

`;

